import { Injectable } from "@angular/core";
import { Action, State, StateContext, StateToken } from "@ngxs/store";
import { BackToUrlStorageAction, CountryListStorageAction } from "./home.action";
import { CommonStoreModel, CountryListModel } from "./home.model";

export const initialHomeState: CommonStoreModel = {
  backTo: null
};

export const STATE_HOME = new StateToken<CommonStoreModel>('common');

@State({
  name: STATE_HOME,
  defaults: initialHomeState
})

@Injectable()
export class CommonState
{
  constructor()
  {

  }

  @Action(BackToUrlStorageAction)
  setMenuObj(ctx: StateContext<CommonStoreModel>, action: BackToUrlStorageAction)
  {
    ctx.patchState(
      {
        backTo: action.backTo
      }
    );
  }

  @Action(CountryListStorageAction)
  setCountry(ctx: StateContext<CountryListModel>, action: CountryListStorageAction)
  {
    ctx.patchState({
      countries: action.country
    });
  }

}